import BaseService from '../../base/base_service';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import Model from './hybrid_version_handler_model';
import ServiceFactory from "../service_factory";
import Device from '../../utils/device/device';

/**
 * The hybrid service initialise the correct hybrid(IOS,Android)
 * The service send messages to the hybrid.
 * The service receive messages from the hybrid - by promise
 *
 *
 */
class HybridVersionHandlerService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridVersionHandlerService';


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = Model.create(params);
    }

    /**
     * Open application store according to device(IOS/Android)
     * @private
     */
    _openApplicationStore(linkProperties) {
        ServiceFactory.create().openLinkService().openLink(linkProperties);
    }

    /**
     * Open mdp message to the user to upgrade Hybrid version.
     * @param messageType
     * @private
     */
    _showMessage(messageType) {
        let langService = ServiceFactory.create().languageService();
        let category = messageType === 'regular' ? 'mobile_upgrade_message' : 'mobile_block_message';
        let buttons = [{isClosable: false, name: langService.translation('hybrid_version_message_upgrade_button'), type: 'main', callback: () => {

            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: category,
                action: 'upgrade'
            });
            // Open appstore/ google play
            this._openApplicationStore({
                view: 'window',
                source: 'common_link',
                sourceLink: this._model.getApplicationStore()
            });
        }}];

        // We have not now button only in regular message and not in block message
        if(messageType === 'regular') {
            buttons.push({name: langService.translation('hybrid_version_message_not_now_button'), type: 'secondary', callback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: category,
                    action: 'not_now'
                });
            }});
        }

        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            title: langService.translation('hybrid_version_message_title'),
            text: langService.translation('hybrid_version_message_body'),
            closeButton: messageType === 'regular',
            hasDefaultButton: false,
            buttons: buttons
        });
    }

    /**
     * Show low version block message
     * @private
     */
    _showLowVersionBlockMessage() {
        this._showMessage('block');
    }

    /**
     * Show low version regular message
     * @private
     */
    _showLowVersionRegularMessage() {
        this._showMessage('regular');
    }


    /**
     * return if the user version is lower then min version
     * @param userVersion
     * @param minVersion
     * @private
     */
    _isLowerThenMinVersion(userVersion, minVersion) {
        if(typeof userVersion === 'string' || typeof minVersion === 'string') {
            userVersion = userVersion.split('-')[0];
            let userSubVersions = userVersion.split('.'),
                minSubVersions = minVersion.split('.');
            if(userSubVersions.length !== minSubVersions.length) {
                this._logger.error('[HybridVersionHandlerService] Hybrid min version have '+ minSubVersions.length + ' while user version ' + userSubVersions.length);
            } else {
                for(let index=0; index<userSubVersions.length; index++) {
                    if(Number(minSubVersions[index]) > Number(userSubVersions[index])) {
                        return true;
                    } else if(Number(minSubVersions[index]) < Number(userSubVersions[index])) {
                        return false;
                    }
                }
            }
        }

        return false;
    }

    doAsyncJobs() {
        // Listen to the Hybrid version only if you are in Hybrid and the block/message feature enable(not empty)
        this.onSystemEventOnce(SYSTEM_EVENTS.ADD_TAG_OPEN_APP_VER, (version)=> {
            if((Device.hybrid.inCasino) &&(this._model.getBlockMinVersion() || this._model.getMessageMinVersion())) {
                if(this._model.getBlockMinVersion()) {
                    // Check if the user version is lower then the needed.
                    if(this._isLowerThenMinVersion(version.toString(), this._model.getBlockMinVersion())) {
                        this._showLowVersionBlockMessage();
                        return;
                    }
                }
                if(this._model.getMessageMinVersion()){
                    // Check if the user version is lower then the needed.
                    if(this._isLowerThenMinVersion(version.toString(), this._model.getMessageMinVersion())) {
                        this._showLowVersionRegularMessage();
                    }
                }
            }
        });
    }

    showUserWrongAppMessage(appStoreLink) {
        this.serviceFactory.messageManagerService().openMessage({
            closeButton: false,
            customCSSClassList: ['cgp-mdp-text-support-slash-n', 'cy-wrong-app-message'],
            title: this.serviceFactory.languageService().translation('hybrid_version_not_available_title'),
            text: this.serviceFactory.languageService().translation('hybrid_version_not_available'),
            buttons: [
                {
                    name: this.serviceFactory.languageService().translation('hybrid_version_not_available_download').toUpperCase(),
                    isClosable: false,
                    callback: () => {
                        this._openApplicationStore({
                            view: 'window',
                            source: 'common_link',
                            sourceLink: appStoreLink
                        });
                    }
                }
            ]
        });
    }
}
export default HybridVersionHandlerService;